import { Row } from 'react-table';

import { COLUMN_IDS, summarizeRowsAbove } from '../constants';
import { getSubRowMatchData } from '.';

/**
 * Calculates a gap value from an array of rows.
 * @param rows - the array of rows
 * @param useCurrentCheckedState - when false, the original `.include` property of the
 * {@link TrqkGapChannelAudio} is used to determine whether detections are included or not when
 * summing the gap value.
 * @param checkLength - when true, the length of rows is taken into account to determine the value
 * @returns the difference between number of detections for audio files that have been selected to
 * be included in the report vs. the number of performances for a given statement work.
 */
export const getGapForRows = (
    rows: Row<TrqkGapChannelAudio>[],
    useCurrentCheckedState = true,
    checkLength = true,
): number => {
    if (checkLength && rows.length <= summarizeRowsAbove) {
        // If we are dealing with a grouped row that only contains zero or one subRow, we can just
        // use row value itself
        return rows[0].values?.[COLUMN_IDS.GAP] ?? 0;
    }

    // For a grouped row with more sub-rows, we must use only the detections for works that have
    // been selected to include in the report
    const { matchedWorkPerformances, includedDetections } = getSubRowMatchData(
        rows,
        useCurrentCheckedState,
    );

    return includedDetections - matchedWorkPerformances;
};
